import { apiClient } from "@base/api/client";
import type { Profile } from "@features/myinfo/model/types";

/**
 * GET /82office/membership/api/profile
 * 프로필 조회
 */
export async function fetchProfile(): Promise<Profile> {
  const { data } = await apiClient.get<Profile>("/82office/membership/api/profile");
  return data;
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useQuery } from "@tanstack/react-query";
 * import { fetchProfile } from "@features/myinfo/api/profile";
 *
 * const { data, isLoading, error } = useQuery({
 *   queryKey: ["profile"],
 *   queryFn: fetchProfile,
 * });
 */
